<template>
  <div class="lightbox-contents">
    <div class="lightbox-contents__ttl">パスワードリセット</div>
      <div class="notification">
        <p>登録しているEmailアドレスを入力して、<br class="sp-on">リセットボタンを押してください。<br>指定のメールアドレスに再設定された<br class="sp-on">パスワードが送付されます。</p>
      </div>
    <div class="add-single-box-input">
      <input type="text" class="form-text-skelton" placeholder="Email" v-model="email">
    </div>
    <div class="lightbox-contents__btn-class">
      <a href="#" class="btn" @click="addClass">リセット</a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        email: ""
      }
    },
    methods: {
      addClass(e) {
        e.preventDefault();

        this.$store.dispatch("passwordReset", this.email);
      }
    }
  }
</script>


<style>
  .notification {
    padding: 0 50px 30px;
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 768px){
    .notification {
      padding: 0 10px 30px;
      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lightbox/PasswordReset.vue